<template>
  <div>
    <div>
      <div class="bg">
        <Nav title="游客满意" @getTime="getTime" @address="address"/>
        <div class="allStyle">
          <div style="width: 64%;padding: 10px;">
            <div style="display: flex;justify-content: space-between;align-items: center">
              <div class="backGround-line">满意度统计</div>
              <div>
                <el-button size="mini" style="visibility: hidden">占位元素</el-button>
              </div>
            </div>
            <div class="left-mask-content">
              <div style="width: 50%;height: 100%;">
                <div class="backGround-line">主要OTA来源</div>
                <div id="overAllChart" style="width: 100%;height: 100%;"></div>
              </div>
              <div style="width: 50%;height: 100%;">
                <div class="backGround-line">游客评分排名</div>
                <div id="ScoreRank" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
            <div class="left-mask-content">
              <div style="width: 33%;height: 100%;">
                <div style="height: 10%;" class="backGround-line">满意度总体分析</div>
                <div id="SatisfactionAnalyse" style="width: 100%;height: 90%;"></div>
              </div>
              <div style="width: 33%;height: 100%;">
                <div style="height: 10%;" class="backGround-line">情绪占比图</div>
                <div id="TourismEmotionRate" style="width: 100%;height: 90%;"></div>
              </div>
              <div style="width: 33%;height: 100%;">
                <div style="height: 10%;" class="backGround-line">指标热议度</div>
                <div id="heatOfDiscussion" style="width: 100%;height: 90%;"></div>
              </div>
            </div>
          </div>
          <div style="width: 35%;padding: 10px;height: 100%;display: flex;flex-direction: column;justify-content: space-between">
            <div style="height: 45%;">
              <div style="display:flex;justify-content: space-between;align-items: center">
                <div class="backGround-line">游客评价数据量统计</div>
<!--                <el-button @click="openIsMaskVisible" size="mini" style="background-color: transparent"-->
<!--                           icon="el-icon-plus">更多-->
<!--                </el-button>-->
              </div>
              <div style="margin-top: 10px;height: 100%">
                <div style="background-color: #111b27;height: 100%;margin-top: 10px;border-radius: 12px;padding: 10px;">
                  <div style="text-align: center;padding: 10px;height: 20%">
                    <div style="width: 60%;margin: 0 auto;" class="backGround-line">游客评价总量 = OTA数据总量 +
                      微博数据总量
                    </div>
                    <div style="width: 60%;margin: 0 auto;display: flex;justify-content: space-evenly">
                      <countTo :startVal="0" :endVal="totalEvaluation.totalCount" :duration="2000"></countTo>
                      <countTo :startVal="0" :endVal="totalEvaluation.ota_count" :duration="2000"></countTo>
                      <countTo :startVal="0" :endVal="totalEvaluation.weiboCount" :duration="2000"></countTo>
                    </div>
                  </div>
                  <div id="dataTrends" style="width: 100%;height: 80%;"></div>
                </div>
              </div>
            </div>
            <div style="height: 45%;">
              <div class="backGround-line">评价数量统计</div>
              <div style="height: 90%;">
                <div style="height: 100%;">
                  <div class="overflow-box">
                    <div v-for="(i, index) in getLatestOtaOptions.slice(0, 10)" :key="index" style="height: 65px;"
                         :class="[index % 2 != 0 ? 'bgColor' : '']">
                      <div style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                        <div style="display: flex;justify-content: left;align-items: center;width: 85%;">
                          <div style="text-align: left">{{ index + 1 }}</div>
                          <div class="text-multi-line-ellipsis">{{ i.content }}</div>
                        </div>
                      </div>
                      <div style="padding: 5px;display: flex;justify-content: space-between;align-items: center;">
                        <div>
                          <i class="el-icon-location-outline"></i>
                          {{ i.poi_name }}
                        </div>
                        <div style="display: flex;justify-content: left;align-items: center;">
                          <i class="el-icon-picture-outline-round"></i>
                          <div>{{ i.source }}</div>
                        </div>
                        <div>
                          <i class="el-icon-time"></i>
                          {{ i.cmt_time }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMaskVisible" class="mask" @click.self="closeMask">
        <div class="mask-content">
          <div style="display: flex;justify-content: right;align-items: center">
            <div style="width: 20%">
              <el-date-picker
                  style="background-color: transparent"
                  v-model="dataTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :popper-append-to-body="index"
                  @change="handCalendar"
              >
              </el-date-picker>
            </div>
            <div style="width: 20%">
              <el-select v-model="value" style="background-color: #fff;margin-right: 5px;border-radius: 12px" placeholder="数据筛选">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div style="width: 20%">
              <input-search v-model="title" @focus="focus" @blur="blur" @search="handEnter"/>
            </div>
          </div>
          <!--遮罩层里的数据-->
          <!--遮罩层没显示出来的数据-->
          <div style="position: absolute;left: 50%;bottom: 20px;transform: translateX(-50%)">
            <el-pagination
                class="custom-pagination"
                layout="prev, pager, next"
                @current-change="currentChange"
                :total="50">
            </el-pagination>
            <el-button @click="isMaskVisible=false" style="background-color: transparent">关闭</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import inputSearch from "@/components/inputSearch/inputSearch.vue";
import {
  SatisfactionGetTouristEvaluationNum,
  SatisfactionGetOtaSource,
  SatisfactionGetTouristScoreRank,
  SatisfactionGetSatisfactionAnalyse,
  SatisfactionGetTourismEmotionRate,
  SatisfactionGetLatestOtaOptions
} from '@/request/touristSatisfaction/touristSatisfaction'
import countTo from 'vue-count-to';
import Nav from '_c/Nav/Nav.vue'
// import dataTable from "@/components/dataTable/dataTable.vue";
import * as echarts from 'echarts';

export default {
  components: {inputSearch, Nav, countTo},
  data() {
    return {
      loading:true,  // 骨架屏，占位元素
      isMaskVisible: false, // 控制遮罩是否显示
      title: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      totalEvaluation: {}, // 评价总量
      getOtaSource: {},// OTA数据
      getTouristScoreRank: [], // 游客评分排名数据
      getSatisfactionAnalyse: [], // 满意度总体分析数据
      getTourismEmotionRate:[], // 游客情绪占比
      getLatestOtaOptions:[], // 最新数据
      chart_1: null, // 评价总量图实列
      chart_2: null, // OTA图实列
      chart_3: null, // 游客评分排名图实列
      chart_4: null, // 满意度总统分析实列
      chart_5: null, // 情绪占比图实列
      chart_6: null, // 指标热议度
      value: '',
      dataTime: '', // 传来的时间数组
      index: true,
      cards: '',
    }
  },
  methods: {
    // 默认加载的游客评价数量
    SatisfactionGetTouristEvaluationNum() {
      this.chart_1 = echarts.init(document.getElementById('dataTrends'));
      SatisfactionGetTouristEvaluationNum().then(res => {
        this.totalEvaluation = res.data.data
        const dataList1 = this.totalEvaluation.list.map(item => {
          return item.ota
        })
        const dataList2 = this.totalEvaluation.list.map(item => {
          return item.weibo
        })
        const dataTime = this.totalEvaluation.list.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['OTA数据总量', '微博数据总量'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: 'OTA数据总量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '微博数据总量',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#33FFF6'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: 'OTA数据总量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '微博数据总量',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_1.setOption(option);
      })
    },
    // 默认加载的OTA数据总量
    SatisfactionGetOtaSource() {
      this.chart_2 = echarts.init(document.getElementById('overAllChart'));
      SatisfactionGetOtaSource().then(res => {
        this.getOtaSource = res.data.data
        const Xdata = this.getOtaSource.name
        const Ydata = this.getOtaSource.value
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'axis', // 按坐标轴触发（适合柱状图）
            axisPointer: {
              type: 'shadow' // 阴影指示器（可选：line、shadow、none）
            },
            backgroundColor: '#fff', // 提示框背景色
            textStyle: {
              color: '#000000' // 提示框文字颜色
            },
            // 可选：自定义提示框内容
            formatter: function (params) {
              return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: Xdata,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: Ydata,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        }
        this.chart_2.setOption(option)
      })

    },
    // 默认加载的游客评分排名
    SatisfactionGetTouristScoreRank() {
      this.chart_3 = echarts.init(document.getElementById('ScoreRank'));
      SatisfactionGetTouristScoreRank().then(res => {
        this.getTouristScoreRank = res.data.data
        const legend = this.getTouristScoreRank.map(item => {
          return item.name
        });
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 时间段
        var xAxisData = this.getTouristScoreRank[0].list.map(item => {
          return item.name
        })

        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              type: 'line',
              itemStyle: {color: colors[i]},
              label: {show: false},
              data: this.getTouristScoreRank[i].list.map(item => {
                return item.value
              })
            }
            list.push(obj)
          }
          return list
        }
        this.chart_3.setOption({
          grid: {
            top: 70,
            bottom: 70,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          series: updateChart()
        })
      })
    },
    // 默认加载的满意度总体分析
    SatisfactionGetSatisfactionAnalyse() {
      this.chart_4 = echarts.init(document.getElementById('SatisfactionAnalyse'));
      SatisfactionGetSatisfactionAnalyse().then(res => {
        this.getSatisfactionAnalyse = res.data.data
        // 景点的数量
        const dataName = this.getSatisfactionAnalyse.map(item => {
          return item.name
        })
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 景点各个配套设施
        const scenicFacilities = this.getSatisfactionAnalyse[0].list.map(item => (
            {
              name: item.name,
            }
        ))
        const updateChart = () => {
          const list = []
          for (let i = 0; i < dataName.length; i++) {
            const obj = {
              type: 'radar',
              symbolSize: 3,
              animation: true,
              lineStyle: {
                color: colors[i],
                width: 1,
              },
              itemStyle: {
                color:  colors[i],
              },
              data: [
                {
                  name: dataName[i],
                  value: this.getSatisfactionAnalyse[i].list.map(item => {
                    return item.value
                  }),
                },
              ],
              emphasis: {
                areaStyle: {
                  opacity: 0.3,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(17,95,234,1)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(17,95,234,0)',
                      },
                    ],
                  },
                },
              },
            }
            list.push(obj)
          }
          return list
        }
        this.chart_4.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            show: true,
            backgroundColor: 'rgba(17,95,234,0.3)',
            textStyle: {
              color: '#F0F0F0',
              fontSize: 10,
            },
            trigger: 'item',
            borderWidth: 0,
            padding: 0,
            axisPointer: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          },
          legend: {
            show: true,
            textStyle: {
              color: '#353bbc',
              fontSize: 12,
            },
            position: {
              left: 'center',
              top: 'top',
            },
            left: 'right',
            top: 'top',
            data: dataName,
          },
          color: ['#115FEA', '#10EBE3', '#10A9EB', '#EB9C10', '#2E10EB', '#9B10EB'],
          radar: {
            shape: 'polygon',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                ],
              },
            },
            name: {
              color: '#FFF',
              padding: 0,
              rich: {
                a: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  lineHeight: 30
                },
                b: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#115FEA',
                  align: 'left'
                },
                c: {
                  fontSize: 14,
                  color: '#fff',
                  padding: [0, 10, 0, 5],
                  align: 'left'
                },
                d: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#10EBE3',
                  align: 'left'
                },
              }
            },
            axisNameGap: 10,
            indicator: scenicFacilities,
            center: ['50%', '50%'],
            radius: '75%',
          },
          series: updateChart()
        })
      })
    },
    // 默认加载游客情绪占比
    SatisfactionGetTourismEmotionRate() {
      this.chart_5 = echarts.init(document.getElementById('TourismEmotionRate'))
      SatisfactionGetTourismEmotionRate().then(res=>{
        this.getTourismEmotionRate = res.data.data

        var data = this.getTourismEmotionRate.value.map(((item, index) => {
          return {
            value: item,
            name: this.getTourismEmotionRate.name[index]
          }
        }))
        const option = {
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",],

          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "40%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        }
        this.chart_5.setOption(option)
      })
    },
    //
    SatisfactionGetLatestOtaOptions() {
      SatisfactionGetLatestOtaOptions().then(res=>{
        this.getLatestOtaOptions = res.data.data
      })
    },

    // 指标热议度
    SatisfactionGetLatestOtaHeatDiscussion(){
      this.chart_6 = echarts.init(document.getElementById('heatOfDiscussion'))
      const Xdata = ['服务态度','排队时间','卫生情况','排队太长','厕所很脏']
      // const Ydata = ['12','23','23','35','2']
      const Ydata = []
      for (let i = 0; i < 5; i++) {
        Ydata.push(Math.floor(Math.random() * 100) + 1)
      }
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis', // 按坐标轴触发（适合柱状图）
          axisPointer: {
            type: 'shadow' // 阴影指示器（可选：line、shadow、none）
          },
          backgroundColor: '#fff', // 提示框背景色
          textStyle: {
            color: '#000000' // 提示框文字颜色
          },
          // 可选：自定义提示框内容
          formatter: function (params) {
            return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: Xdata,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#063374",
              width: 1,
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#00c7ff",
              fontSize: "8"
            },
            interval: 0, // 强制显示所有标签

          },
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            },
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: "#063374",
            }
          }
        }],
        series: [{
          type: 'bar',
          data: Ydata,
          barWidth: 20,
          barGap: 1, //柱子之间间距
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00fcae'
              }, {
                offset: 1,
                color: '#006388'
              }]),
              opacity: 1,
            }
          }
        }]
      }
      this.chart_6.setOption(option)
    },
    async getTime(value) {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.dataTime = {
        startTime: value[0],
        endTime: value[1],
      }
      // 选择时间后触发新的总评价数据
      await SatisfactionGetTouristEvaluationNum(this.dataTime).then(res => {
        this.totalEvaluation = res.data.data
        this.chart_1 = echarts.init(document.getElementById('dataTrends'));
        const dataList1 = this.totalEvaluation.list.map(item => {
          return item.ota
        })
        const dataList2 = this.totalEvaluation.list.map(item => {
          return item.weibo
        })
        const dataTime = this.totalEvaluation.list.map(item => {
          return item.day
        })
        const option = {
          backgroundColor: 'transparent', // 暗色背景
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'} // 十字准星指示器
          },
          legend: {
            data: ['OTA数据总量', '微博数据总量'],
            textStyle: {color: '#fff'}
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: dataTime,
            axisLine: {lineStyle: {color: '#666'}},
            axisLabel: {color: '#f4e2e5'}
          },
          yAxis: [
            {
              type: 'value',
              name: 'OTA数据总量',
              position: 'left',
              axisLine: {
                lineStyle: {color: '#f4e2e5'}, // 左轴颜色
                show: true
              },
              splitLine: {lineStyle: {type: 'dashed', color: '#333'}}
            },
            {
              type: 'value',
              name: '微博数据总量',
              position: 'right',
              axisLine: {
                lineStyle: {color: '#33FFF6'}, // 右轴颜色
                show: true
              },
              splitLine: {show: false}, // 隐藏右轴网格线
              axisLabel: {
                formatter: '{value}%' // 显示百分比
              }
            }
          ],
          series: [
            {
              name: 'OTA数据总量',
              type: 'line',
              data: dataList1,
              lineStyle: {width: 3, color: '#FFFFFF'},
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {color: '#FFFFFF'}
            },
            {
              name: '微博数据总量',
              type: 'line',
              yAxisIndex: 1, // 绑定到右Y轴
              data: dataList2, // 百分比数据（无需手动转换）
              lineStyle: {width: 3, color: '#33FFF6'},
              symbol: 'none', // 不显示数据点
              itemStyle: {color: '#33FFF6'},
              areaStyle: { // 填充区域
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgba(88, 214, 141, 0.3)'},
                  {offset: 1, color: 'rgba(88, 214, 141, 0)'}
                ])
              }
            }
          ]
        };
        this.chart_1.setOption(option);
      })
      // 选择时间后触发新的OTA数据
      await SatisfactionGetOtaSource(this.dataTime).then((res) => {
        this.getOtaSource = res.data.data
        const Xdata = this.getOtaSource.name
        const Ydata = this.getOtaSource.value
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'axis', // 按坐标轴触发（适合柱状图）
            axisPointer: {
              type: 'shadow' // 阴影指示器（可选：line、shadow、none）
            },
            backgroundColor: '#fff', // 提示框背景色
            textStyle: {
              color: '#000000' // 提示框文字颜色
            },
            // 可选：自定义提示框内容
            formatter: function (params) {
              return `${params[0].axisValue}<br/>数量: ${params[0].value}`;
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: Xdata,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: Ydata,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        }
        this.chart_2.setOption(option)
      })
      // 选择时间后触发新的游客评分排名
      await SatisfactionGetTouristScoreRank(this.dataTime).then((res) => {
        this.getTouristScoreRank = res.data.data
        const legend = this.getTouristScoreRank.map(item => {
          return item.name
        });
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 时间段
        var xAxisData = this.getTouristScoreRank[0].list.map(item => {
          return item.name
        })
        const updateChart = () => {
          var list = []
          for (let i = 0; i < legend.length; i++) {
            var obj = {
              name: legend[i],
              type: 'line',
              itemStyle: {color: colors[i]},
              label: {show: false},
              data: this.getTouristScoreRank[i].list.map(item => {
                return item.value
              })
            }
            list.push(obj)
          }
          return list
        }
        this.chart_3.setOption({
          grid: {
            top: 70,
            bottom: 70,
            left: 65,
            right: 65
          },
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '25%'];
            }
          },
          legend: {
            data: legend,
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
          },
          series: updateChart()
        })
      })
      // 选择时间后触发新的满意度分析
      await SatisfactionGetSatisfactionAnalyse(this.dataTime).then((res) => {
        this.getSatisfactionAnalyse = res.data.data
        // 景点的数量
        const dataName = this.getSatisfactionAnalyse.map(item => {
          return item.name
        })
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        // 景点各个配套设施
        const scenicFacilities = this.getSatisfactionAnalyse[0].list.map(item => (
            {
              name: item.name,
            }
        ))
        const updateChart = () => {
          const list = []
          for (let i = 0; i < dataName.length; i++) {
            const obj = {
              type: 'radar',
              symbolSize: 3,
              animation: true,
              lineStyle: {
                color: colors[i],
                width: 1,
              },
              itemStyle: {
                color:  colors[i],
              },
              data: [
                {
                  name: dataName[i],
                  value: this.getSatisfactionAnalyse[i].list.map(item => {
                    return item.value
                  }),
                },
              ],
              emphasis: {
                areaStyle: {
                  opacity: 0.3,
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: 'rgba(17,95,234,1)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(17,95,234,0)',
                      },
                    ],
                  },
                },
              },
            }
            list.push(obj)
          }
          return list
        }
        this.chart_4.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            show: true,
            backgroundColor: 'rgba(17,95,234,0.3)',
            textStyle: {
              color: '#F0F0F0',
              fontSize: 10,
            },
            trigger: 'item',
            borderWidth: 0,
            padding: 0,
            axisPointer: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          },
          legend: {
            show: true,
            textStyle: {
              color: '#353bbc',
              fontSize: 12,
            },
            position: {
              left: 'center',
              top: 'top',
            },
            left: 'right',
            top: 'top',
            data: dataName,
          },
          color: ['#115FEA', '#10EBE3', '#10A9EB', '#EB9C10', '#2E10EB', '#9B10EB'],
          radar: {
            shape: 'polygon',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(34,36,42, 1)',
              },
            },
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 1)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                  'rgba(34,36,42, 0)',
                ],
              },
            },
            name: {
              color: '#FFF',
              padding: 0,
              rich: {
                a: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  lineHeight: 30
                },
                b: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#115FEA',
                  align: 'left'
                },
                c: {
                  fontSize: 14,
                  color: '#fff',
                  padding: [0, 10, 0, 5],
                  align: 'left'
                },
                d: {
                  width: 8,
                  height: 8,
                  backgroundColor: '#10EBE3',
                  align: 'left'
                },
              }
            },
            axisNameGap: 10,
            indicator: scenicFacilities,
            center: ['50%', '50%'],
            radius: '75%',
          },
          series: updateChart()
        })
      })
      // 选择时间后触发新的情绪占比
      await SatisfactionGetTourismEmotionRate(this.dataTime).then(res=>{
        this.getTourismEmotionRate = res.data.data
        var data = this.getTourismEmotionRate.value.map(((item, index) => {
          return {
            value: item,
            name: this.getTourismEmotionRate.name[index]
          }
        }))
        const option = {
          color: ["#FF5733",
            "#33FF57",
            "#3357FF",],

          legend: {
            show: true,
            bottom: "10%",
            icon: "circle",
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          title: [
            {
              left: "0",
              top: "0",
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            {
              textStyle: {
                color: "#fff",
                fontSize: "12px",
                fontWeight: "normal",
              },
              subtextStyle: {
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
              },
              top: "center",
              left: "center",
            },
          ],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["30%", "55%"],
              center: ["50%", "40%"],
              avoidLabelOverlap: false,
              label: {
                formatter: `{b|{d}%}`,
                alignTo: "labelLine",
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: "12px",
                  },
                  b: {
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  },
                },
              },
              labelLine: {
                lineStyle: {
                  cap: "round",
                },
              },
              data: data,
            },
          ],
        }
        this.chart_5.setOption(option)
        loading.close();
      })
      this.SatisfactionGetLatestOtaHeatDiscussion()


      loading.close();
    },
    address(value) {
      console.log(value)
    },
    focus() {
      console.log(111)
    },
    blur() {
      console.log(222)
    },
    handEnter() {
      console.log(this.title)
    },
    handCalendar() {
      if (!this.dataTime || this.dataTime.length < 2) return;

      function formatDateToYMD(date) {
        const y = date.getFullYear().toString(); // 年份后两位
        const m = ('0' + (date.getMonth() + 1)).slice(-2); // 月份补零
        const d = ('0' + date.getDate()).slice(-2); // 日期补零
        return `${y}-${m}-${d}`;
      }

      // 处理 value1 中的两个日期
      const formattedDates = this.dataTime.map(date => formatDateToYMD(date));
      console.log('格式化后的时间:', formattedDates);
    },
    currentChange(e) {
      console.log(e)
      this.data = [
        {name: '总体满意度', value: 9300, satisfaction: 93, desc: '近30天平均值'},
        {name: '好评数量', value: 12543, satisfaction: 94, desc: '评分 ≥ 4星'},
        {name: '差评数量', value: 876, satisfaction: 65, desc: '评分 ≤ 2星'},
        {name: '评价总数', value: 13419, satisfaction: 89, desc: '已收集评价'},
        {name: '景区卫生评分', value: 89, satisfaction: 89, desc: '满分100分'},
        {name: '服务人员满意度', value: 91, satisfaction: 91, desc: '员工服务评分'},
        {name: '排队时间满意度', value: 78, satisfaction: 78, desc: '等待体验评分'},
        {name: '设施维护评分', value: 85, satisfaction: 85, desc: '设备完好率'},
        {name: '导览系统评分', value: 82, satisfaction: 82, desc: '导航与标识清晰度'},
        {name: '餐饮满意度', value: 76, satisfaction: 76, desc: '餐厅/小吃评分'}
      ]
    },

    openIsMaskVisible() {
      this.isMaskVisible = true
    },

    handleResize() {
      this.chart_1.resize()
      this.chart_2.resize()
      this.chart_3.resize()
      this.chart_4.resize()
      this.chart_5.resize()
      this.chart_6.resize()
    }
  },
   created() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.$nextTick(async () => {
     await this.SatisfactionGetTouristEvaluationNum()  // 默认加载的游客评价数量
     await this.SatisfactionGetOtaSource()   // 默认加载OTA数据
     await this.SatisfactionGetTouristScoreRank() // 默认加载游客评分排名
     await this.SatisfactionGetSatisfactionAnalyse()  // 游客满意度分析
     await this.SatisfactionGetTourismEmotionRate()  // 默认加载的游客情绪占比
     await this.SatisfactionGetLatestOtaOptions()  // 默认加载的最新数据
      await this.SatisfactionGetLatestOtaHeatDiscussion()  // 指标热议度
      loading.close()
    })
    window.addEventListener('resize',this.handleResize);
  },
  beforeDestroy() {
     window.removeEventListener('resize',this.handleResize);
  }
}
</script>
<style scoped lang="scss">


.allStyle {
  flex: 1;
  color: white;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

}

.mask {
  position: fixed;
  text-shadow: 0 0 5px white; /* 这会导致白光圈 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 111;
}

/* 内容区域 */
.mask-content {
  width: 90%;
  background-color: rgba(15, 19, 37,1);
  padding: 30px;
  height: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  min-width: 300px;
  position: relative;
}

.left-mask-content {
  background-color: #111b27;
  height: 45%;
  margin-top: 10px;
  border-radius: 12px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/*select 会被遮罩层给盖住 */
.el-select-dropdown {
  z-index: 99999 !important;
  color: black;
}

.el-select .el-input__inner {
  padding: 0 15px !important;
  border-radius: 4px;
}


.el-select-dropdown__item {
  color: black;
}

.data-box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  padding: 20px 0;
  height: 100%;
}


.search-input[data-v-6dcc6596] {
  color: black !important;
  background-color: #fff !important;
}

/* 分页的样式 */
.custom-pagination {
  background-color: transparent !important;
}

:deep(.custom-pagination .el-pager li) {
  background-color: transparent !important;
  color: white !important; /* 可选：文字颜色 */
}

:deep(.custom-pagination .el-pager li.active) {
  background-color: #00d1b2 !important; /* 当前页码背景 */
  color: white !important;
}

:deep(.custom-pagination button) {
  background-color: transparent !important;
  color: white !important;
}

:deep(.custom-pagination button:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}


:deep(.el-range-editor .el-range-input){
  background-color: transparent;
}
:deep(.el-select){
  background-color: transparent !important;
}

.bgColor {
  background-color: rgb(255, 255, 255, 0.1);
}

.text-multi-line-ellipsis {
  display: -webkit-box;
  /* 老式弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 内容垂直排列 */
  -webkit-line-clamp: 1;
  /* 最多显示几行 */
  overflow: hidden;
  /* 隐藏多余内容 */
  text-overflow: ellipsis;
  /* 溢出部分显示省略号 */
  margin-left: 5px;
}

.overflow-box {
  max-height: calc(100% - 30px);
  /* 假设每条高 60px，最多显示 10 条 */
  overflow-y: auto;
  /* 可选：加个边框好看点 */
  padding: 5px;
  color: white;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>
